import * as topojson from 'topojson-client'

import { BaseMap } from './base-map'
import globalTopology from './topology/global-countries.json'
import letterCodes from './topology/global-country-mapping.json'
import { TooltipContextProvider } from '../common/tooltip/tooltip.context'

const topology = getCountryTopology(globalTopology)

const DEFAULT_WIDTH = 1024
const isFirefox = navigator.userAgent.indexOf('Firefox') !== -1
const alignValue = isFirefox ? '-moz-center' : '-webkit-center'

export const GlobalMap = ({
  useLetterCodes = false,
  width = DEFAULT_WIDTH,
  height = width / (DEFAULT_WIDTH / 550),
  enableZoom = false,
  mapKeyPosition,
  ...props
}) => {
  const legendProperties = width <= 887 ? {
    bottom: height / 11, // When height is 550, this is bottom: 100px
    left: width / 20.48, // When width is 1024, this is left: 800px
    position: 'unset',
    textAlign: alignValue
  } : {
    bottom: height / 11, // When height is 550, this is bottom: 100px
    left: width / 20.48 // When width is 1024, this is left: 800px
  }
  // Key is absolutely positioned within the div wrapper around the SVG
  mapKeyPosition = mapKeyPosition || legendProperties

  const mapRegionInfo = (x) => {
    // if using ids, convert to number because its harder to get input data with leading zeros
    let code = useLetterCodes ? letterCodes[x.id] : Number(x.id)

    // Some features don't have an id
    if (!useLetterCodes && isNaN(code)) {
      code = undefined
    }

    return {
      code,
      name: x.properties.name
    }
  }

  const standardProjectionProps = {
    scale: 130,
    translate: [ 500, 380 ],
    rotate: [-10, 0]
  }

  return (
    <TooltipContextProvider>
      <BaseMap
        width={width}
        height={height}
        topology={topology}
        mapRegionInfo={mapRegionInfo}
        regionLabel="site"
        projectionProps={standardProjectionProps}
        enableZoom={enableZoom}
        mapKeyPosition={mapKeyPosition}
        {...props}
      />
    </TooltipContextProvider>
  )
}

function getCountryTopology (topoJsonTopology) {
  return topojson.feature(topoJsonTopology, topoJsonTopology.objects.countries)
}
